function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40 3.33325C37.3478 3.33325 34.8043 4.38682 32.9289 6.26218C31.0536 8.13755 30 10.6811 30 13.3333V39.9999C30 42.6521 31.0536 45.1956 32.9289 47.071C34.8043 48.9464 37.3478 49.9999 40 49.9999C42.6522 49.9999 45.1957 48.9464 47.0711 47.071C48.9464 45.1956 50 42.6521 50 39.9999V13.3333C50 10.6811 48.9464 8.13755 47.0711 6.26218C45.1957 4.38682 42.6522 3.33325 40 3.33325V3.33325Z",
  stroke: "#CCCCCC",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.3332 33.3333V39.9999C63.3332 46.1883 60.8748 52.1232 56.499 56.4991C52.1231 60.8749 46.1882 63.3332 39.9998 63.3332C33.8114 63.3332 27.8765 60.8749 23.5007 56.4991C19.1248 52.1232 16.6665 46.1883 16.6665 39.9999V33.3333",
  stroke: "#CCCCCC",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40 63.3333V76.6666",
  stroke: "#CCCCCC",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.6665 76.6667H53.3332",
  stroke: "#CCCCCC",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgMic = function SvgMic(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mic.f31bcd47.svg";
export { ForwardRef as ReactComponent };